import { render } from "./TenderManagement.vue?vue&type=template&id=1e0e9d0c&scoped=true"
import script from "./TenderManagement.vue?vue&type=script&lang=js"
export * from "./TenderManagement.vue?vue&type=script&lang=js"

import "./TenderManagement.vue?vue&type=style&index=0&id=1e0e9d0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0e9d0c"]])

export default __exports__